import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";
import { SF_LANDING_OG_URL } from "../../../constants/sf-landing-constants";

const SFLandingPageMetaTags = ({
    metaTitle,
    metaDescription,
    ogTitle,
    ogDescription,
    history
}) => {
    const baseUrl = `${appUrl()}/loan-against-car/ `;
    const pageUrl = `${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`;

    return (
        <Helmet>
            <title>{metaTitle}</title>
            <meta name="title" content={metaTitle} />
            <meta name="description" content={metaDescription} />
            <meta name="ROBOTS" content="INDEX,FOLLOW" />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:description" content={ogDescription} />
            <meta property="og:url" content={`${appUrl()}/`} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Cars24" />
            <meta property="og:image" content={SF_LANDING_OG_URL} />
            <link href={`${baseUrl}`} rel="canonical" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content={`${baseUrl}`} />
            <meta property="twitter:url" content={pageUrl} />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
        </Helmet>
    );
};

SFLandingPageMetaTags.propTypes = {
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    ogTitle: PropTypes.string,
    ogDescription: PropTypes.string,
    history: PropTypes.object
};

export default SFLandingPageMetaTags;
